import { useStudiosListQuery } from "entities/studios/queries/useStudiosListQuery";
import { Studio } from "entities/studios/types";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import PageHeading from "shared/components/PageHeading";
import TableWithPagination from "shared/components/TableWithPagination";
import StudioDetails from "./components/StudioDetails";
import { StudiosPageProvider, useStudiosPage } from "./context";
import { gamesStudiosColumns } from "./helpers";

const StudiosContainer = () => (
  <StudiosPageProvider>
    <Studios />
  </StudiosPageProvider>
);

const Studios = () => {
  const { studioDetailsDrawer } = useStudiosPage();

  const columns = gamesStudiosColumns(studioDetailsDrawer);

  const { data = [], isLoading } = useStudiosListQuery();

  return (
    <FlexColumn>
      <PageHeading />
      <TableWithPagination<Studio>
        data={data}
        columns={columns}
        loading={isLoading}
        emptyStateMessage="No products found"
        sortingMode="client"
        heightTable={"80vh"}
        hideFooter
        onRowClick={(params) => studioDetailsDrawer.openDrawer(params.row)}
      />
      <StudioDetails />
    </FlexColumn>
  );
};

export default StudiosContainer;
